import React from 'react';
import PropTypes from 'prop-types';
import { View, BodyText, InlineLink, Row } from 'modules/styled';

ComponentName.propTypes = {
  messageText: PropTypes.string,
  actionText: PropTypes.string,
  dismissText: PropTypes.string,
  onClick: PropTypes.func,
  onDismiss: PropTypes.func,
};

export default function ComponentName({
  messageText,
  actionText,
  dismissText,
  onClick,
  onDismiss,
}) {
  return (
    <Row sx={{ flex: 1, justifyContent: 'space-between', alignItems: 'center' }}>
      <BodyText>
        {messageText}
        <InlineLink onClick={onClick} to="#">
          <BodyText sx={{ color: 'blue' }}>{actionText}</BodyText>
        </InlineLink>
      </BodyText>
      <View>
        <InlineLink onClick={onDismiss} to="#">
          <BodyText sx={{ color: 'blue' }}>{dismissText}</BodyText>
        </InlineLink>
      </View>
    </Row>
  );
}
